import { c as _c } from "react/compiler-runtime";
import { ChangeManagementDialogContent } from "@pages/project-details/project-overview/change-management/change-management-dialog-content";
import { useGroupMembersContext } from "@context-providers/group-members-provider";
import { useState } from "react";

/** A dialog to change the project manager and group of the current project */
export function ChangeManagementDialog(t0) {
  const $ = _c(14);
  const {
    children
  } = t0;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const {
    canChangeManagement
  } = useGroupMembersContext();
  let t1;
  if ($[0] !== canChangeManagement) {
    t1 = canChangeManagement ? {
      cursor: "pointer"
    } : undefined;
    $[0] = canChangeManagement;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== canChangeManagement) {
    t2 = () => setIsDialogOpen(canChangeManagement);
    $[2] = canChangeManagement;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t1 || $[6] !== t2) {
    t3 = <div style={t1} onClick={t2}>{children}</div>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsDialogOpen(false);
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isDialogOpen) {
    t5 = <ChangeManagementDialogContent isOpen={isDialogOpen} onClose={t4} />;
    $[9] = isDialogOpen;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}